import { IColor, IOption, IRGBA } from "@mindmemobile/mm-shared-global";
import { action, makeAutoObservable, observable } from "mobx";
import {
  ColorModel,
  ProductAttributeOptionsModel,
  ProductAttributesModel,
} from "../../shared/models";
import { AttributeTypes, AttributeValueTypes } from "../../shared/enums";
// class Options {
//     @observable name: string;
//     color?: IColor | null;
//     showColorPicker: boolean;
//     hasError: boolean;
//     constructor(data?: Partial<Options>) {
//         this.name = data?.name || '';
//         this.color = data?.color || null;
//         this.showColorPicker = data?.showColorPicker === true;
//         this.hasError = data?.hasError === true;
//         autorun(() => this.validate(true));
//     }

//     validate(isAutoRun = false) {
//         if (!this.name?.trim()) {
//             if (!isAutoRun) {
//                 this.hasError = true;
//             }
//         } else {
//             this.hasError = false;
//         }
//     }
// }

export const defaultColor = {
  hex: '#e5e5e5',
  isGradient: false,
  gradient: '',
  rgbValue: {
      r: '229',
      g: '229',
      b: '229',
      a: '100',
  } as IRGBA,
} as IColor;

export default class AttributeStore {
  @observable public customAttributes: IOption[] = [];
  @observable public attribute: ProductAttributesModel;

  constructor() {
      this.attribute = new ProductAttributesModel({
          attributeType: AttributeTypes.Custom,
          valueType: AttributeValueTypes.Text,
          name: '',
          options: [
              new ProductAttributeOptionsModel({ color: defaultColor }),
              new ProductAttributeOptionsModel({ color: defaultColor }),
          ],
      });
      makeAutoObservable(this);
  }

  @action
  addCustomAttributes(data?: ProductAttributesModel[]) {
      const dropdownOptions =
          data
              ?.filter((item) => item.attributeType == AttributeTypes.Custom)
              .map((item) => ({
                  label: item.name,
                  value: item.name,
              })) || [];

      if (dropdownOptions.length > 0) {
          this.customAttributes.push(...dropdownOptions);
      }
  }

  @action
  addNewAttribute(data: IOption) {
      this.customAttributes.push(data);
  }

  @action
  clearCustomAttributes() {
      this.customAttributes = [];
  }

  @action
  updateState(data: ProductAttributesModel) {
      this.attribute = new ProductAttributesModel({ ...data });
  }

  @action
  onAddOption() {
      const clonedOptions = this.attribute.options.map((a) => Object.assign({}, a));
      switch (this.attribute.valueType) {
          case AttributeValueTypes.Color:
          default:
              clonedOptions.push(
                  new ProductAttributeOptionsModel({
                      name: '',
                      color: ColorModel.deserializeAPIModel(defaultColor),
                      showColorPicker: false,
                      referenceId: new Date().getTime().toString(),
                  }),
              );

              this.attribute = new ProductAttributesModel({ ...this.attribute, options: clonedOptions });

              break;
      }
  }
  @action
  onUpdateColor(color: IColor, index: number) {
      const clonedOptions = this.attribute.options.map((a) => Object.assign({}, a));
      clonedOptions[index].color = color;
      this.attribute = new ProductAttributesModel({ ...this.attribute, options: clonedOptions });
  }
  @action
  toggleColorPicker(index: number) {
      const clonedOptions = this.attribute.options.map((a) => Object.assign({}, a));
      const isVisible = clonedOptions[index].showColorPicker;
      clonedOptions[index].showColorPicker = !isVisible;
      this.attribute = new ProductAttributesModel({ ...this.attribute, options: clonedOptions });
  }

  @action
  onOptionTextChange(value: string, index: number) {
      const clonedOptions = this.attribute.options.map((a) => Object.assign({}, a));
      clonedOptions[index].name = value;
      this.attribute = new ProductAttributesModel({ ...this.attribute, options: clonedOptions });
  }
  @action
  deleteOption(index: number) {
      const clonedOptions = this.attribute.options.filter((x, idx) => idx != index);
      this.attribute = new ProductAttributesModel({ ...this.attribute, options: clonedOptions });
  }

  @action validate(): boolean {
      const isValid = this.attribute.validate();
      this.attribute = new ProductAttributesModel({ ...this.attribute });
      return isValid;
  }

  // @computed
  // constructSaveUpdateModel(): ICreateUpdateAttributeModel {
  //     return {
  //         name: this.name,
  //         valueType: this.valueType,
  //         type: this.attributeType,
  //         options: this.options.map((opt) => {
  //             return {
  //                 name: opt.name,
  //                 color: opt.color,
  //             } as IAttributeOptionsModel;
  //         }),
  //     } as ICreateUpdateAttributeModel;
  // }
}
